// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__IThKe","subtitleContainer":"Header_subtitleContainer__sWSZ_"};